import React from 'react';
import moment from 'moment';

const phaseColors = ['#286090', '#387549', '#8a5428', '#73538c', '#a33b49', '#276f78'];

function ftoColor(guid) {
  const hash = Array.from(guid).reduce((value, character) => ((value * 31) + character.codePointAt(0)) >>> 0, 0);
  const hue = hash % 360;
  const saturation = 55 + ((hash >>> 9) % 20);
  const lightness = 34 + ((hash >>> 17) % 12);
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

export function groupAssignments(assignments) {
  const groups = new Map();
  assignments.forEach((assignment) => {
    const date = moment(assignment.observationDate).format('YYYY-MM-DD');
    const key = JSON.stringify([date, assignment.oit.guid, assignment.fto && assignment.fto.guid, assignment.phase.guid]);
    if (!groups.has(key)) {
      groups.set(key, {
        id: key,
        date,
        oit: assignment.oit,
        fto: assignment.fto,
        phase: assignment.phase,
        trainingStatus: assignment.trainingStatus,
        start: moment(date).startOf('day').toDate(),
        end: moment(date).add(1, 'day').startOf('day').toDate(),
        allDay: true,
        color: assignment.fto ? ftoColor(assignment.fto.guid) : '#777777',
        phaseColor: phaseColors[Math.abs(assignment.phase.sequence || 0) % phaseColors.length],
        reports: [],
      });
    }
    groups.get(key).reports.push(assignment);
  });
  return Array.from(groups.values()).map(event => ({
    ...event,
    title: React.createElement(
      'div',
      {
        className: 'fto-calendar-event',
        title: `${event.date} · ${event.oit.name} · ${event.fto ? event.fto.name : 'Unassigned'} · ${event.phase.name} · ${event.reports.map(report => `${report.type.toUpperCase()} (${report.status})`).join(', ')}`,
      },
      React.createElement('span', {className: 'phase-color-dot', style: {backgroundColor: event.phaseColor}}),
      React.createElement(
        'span',
        null,
        `${event.oit.name} / ${event.fto ? event.fto.name : 'Unassigned'} / ${event.phase.name} (${event.reports.length})`,
      ),
    ),
  }));
}
